<template>
  <div class="index">
    <van-nav-bar
        title="装修须知"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="van-doc-demo-block__card">
      <van-panel title="装修须知" desc="江山市江城管道燃气有限公司" >
        <div class="doc_title">
          <van-image fit="cover" :src="require('./../assets/img/zxxz.jpg')" />
        </div>
      </van-panel>
    </div>



  </div>
</template>
<script>
export default {
  name: 'page_bind',
  data() {
    return {

    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    }

  },
  mounted () {

  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.doc-demo-block__card {
  margin: 16px 12px 0px;
  overflow: hidden;
  border-radius: 8px;
}
.doc_title {
  margin: 0;
  padding: 22px 16px 0px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>